import React, { useEffect, useState } from 'react';
import { api } from '../../api';
import { Card } from '../../components/ui/card';
import { Badge } from '../../components/ui/badge';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';

export default function AdminReports() {
  const [occupancy, setOccupancy] = useState([]);
  const [vax, setVax] = useState([]);
  const [arr, setArr] = useState({ arrivals: [], departures: [] });
  useEffect(() => {
    api.get('/admin/reports/occupancy', { params: { days: 14 } }).then(r => setOccupancy(r.data.days));
    api.get('/admin/reports/expiring-vaccinations').then(r => setVax(r.data.items));
    api.get('/admin/reports/arrivals-departures').then(r => setArr(r.data));
  }, []);

  return (
    <div className='p-6 lg:p-8'>
      <div className='mb-4'>
        <div className='text-[10px] uppercase tracking-[0.16em] font-bold text-[#C8102E]'>Insights</div>
        <h1 className='font-display text-3xl font-bold text-slate-900 mt-1'>Reports</h1>
      </div>
      <Tabs defaultValue='occupancy' className='space-y-4'>
        <TabsList className='bg-white border border-slate-200'>
          <TabsTrigger value='occupancy' data-testid='tab-occupancy'>Occupancy (14 days)</TabsTrigger>
          <TabsTrigger value='arrivals' data-testid='tab-arrivals'>Today’s Arrivals/Departures</TabsTrigger>
          <TabsTrigger value='vax' data-testid='tab-vax'>Vaccinations Expiring</TabsTrigger>
        </TabsList>
        <TabsContent value='occupancy'>
          <Card className='bg-white border-slate-200 p-4 overflow-x-auto'>
            <table className='w-full text-sm' data-testid='occupancy-table'>
              <thead><tr className='border-b border-slate-200 text-left text-xs text-slate-500'><th className='p-2'>Date</th><th className='p-2'>Occupied</th><th className='p-2'>Total</th><th className='p-2'>%</th><th className='p-2 w-1/3'>Trend</th></tr></thead>
              <tbody>
                {occupancy.map(d => (
                  <tr key={d.date} className='border-b border-slate-200'>
                    <td className='p-2 font-mono'>{d.date}</td>
                    <td className='p-2 tabular-nums'>{d.occupied}</td>
                    <td className='p-2 tabular-nums'>{d.total}</td>
                    <td className='p-2 tabular-nums font-semibold'>{d.pct}%</td>
                    <td className='p-2'><div className='h-2 rounded-full bg-[#1E293B]'><div className='h-full rounded-full' style={{width:`${d.pct}%`, background: d.pct >= 80 ? '#C8102E' : '#1B3A87'}} /></div></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Card>
        </TabsContent>
        <TabsContent value='arrivals'>
          <div className='grid lg:grid-cols-2 gap-4'>
            <Card className='bg-white border-slate-200 p-4'>
              <h3 className='font-display font-semibold mb-3'>Arrivals ({arr.arrivals.length})</h3>
              {arr.arrivals.length === 0 ? <div className='text-slate-500 text-sm'>None.</div> : arr.arrivals.map(a => (
                <div key={a.id} className='p-2 border-b border-slate-200 text-sm'><strong>{a.dog_name}</strong> · {a.client_name} · <span className='font-mono text-xs'>{a.run_name}</span></div>
              ))}
            </Card>
            <Card className='bg-white border-slate-200 p-4'>
              <h3 className='font-display font-semibold mb-3'>Departures ({arr.departures.length})</h3>
              {arr.departures.length === 0 ? <div className='text-slate-500 text-sm'>None.</div> : arr.departures.map(a => (
                <div key={a.id} className='p-2 border-b border-slate-200 text-sm'><strong>{a.dog_name}</strong> · {a.client_name} · <span className='font-mono text-xs'>{a.run_name}</span></div>
              ))}
            </Card>
          </div>
        </TabsContent>
        <TabsContent value='vax'>
          <Card className='bg-white border-slate-200 p-4 overflow-x-auto'>
            {vax.length === 0 ? <div className='text-slate-500 p-4 text-center'>No vaccinations expiring soon.</div> : (
              <table className='w-full text-sm' data-testid='vax-report-table'>
                <thead><tr className='border-b border-slate-200 text-left text-xs text-slate-500'><th className='p-2'>Dog</th><th className='p-2'>Owner</th><th className='p-2'>Vaccine</th><th className='p-2'>Expires</th><th className='p-2'>Status</th></tr></thead>
                <tbody>
                  {vax.map(v => (
                    <tr key={v.id} className='border-b border-slate-200'>
                      <td className='p-2 font-semibold'>{v.dog_name}</td>
                      <td className='p-2'>{v.owner_name}<div className='text-xs text-slate-500 font-mono'>{v.owner_email}</div></td>
                      <td className='p-2'>{v.vaccine_name}</td>
                      <td className='p-2 font-mono'>{v.expiration_date}</td>
                      <td className='p-2'>{v.is_expired ? <Badge className='bg-[#B42318] text-slate-900'>Expired</Badge> : <Badge className='bg-[#B45309] text-slate-900'>Soon</Badge>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
